import type { FC } from 'react';

import { plannerItemNavigationStubConfig } from '@shared/configs/plannerItemNavigationStub.config';
import { Stub } from '@shared/ui-kit';

import type { PlannerItemNavigationEnum } from '@shared/enums/plannerItemNavigation.enum';

type PlannerItemNavigationStubProps = {
  variant: PlannerItemNavigationEnum;
};
export const PlannerItemNavigationStub: FC<PlannerItemNavigationStubProps> = ({ variant }) => {
  const item = plannerItemNavigationStubConfig[variant];
  return (
    <Stub
      config={{
        img: item.icon,
        title: '',
        description: item.description,
      }}
    />
  );
};
